import { hPost } from '@mcfe/tools';

// 商家状态
export const MERCHANT_STATE = {
    NOT_INFO: -1, // 未填写招商信息
    DRAFT: 0, // 草稿
    WAIT_REVIEW: 1, // 待审核
    REVIEWING: 2, // 审核中
    PASS: 3, // 审核通过
    REJECT: 4, // 审核不通过
    ACCESS: 5, // 已准入
    FOLLOW: 6, // 已跟进
    COOPERATIVE: 7, // 合作待定
    ACCESS_CONFIRMED: 8, // 确定准入
    BOUND_MERCHANT: 999, // 已绑定供货规则
};


// 商家不同入驻状态跳转链接
export const STATE_LINK_MAP = {
    [MERCHANT_STATE.NOT_INFO]: '/supplierRecruitment/introduction.html',
    [MERCHANT_STATE.DRAFT]: '/supplierRecruitment.html',
    [MERCHANT_STATE.WAIT_REVIEW]: '/supplierRecruitment/status.html',
    [MERCHANT_STATE.REVIEWING]: '/supplierRecruitment/status.html',
    [MERCHANT_STATE.PASS]: '/vss/intermediatePage.html',
    [MERCHANT_STATE.REJECT]: '/vss/intermediatePage.html',
    [MERCHANT_STATE.ACCESS]: '/vss/intermediatePage.html',
    [MERCHANT_STATE.FOLLOW]: '/vss/intermediatePage.html',
    [MERCHANT_STATE.COOPERATIVE]: '/vss/intermediatePage.html',
    [MERCHANT_STATE.ACCESS_CONFIRMED]: '/vss/intermediatePage.html',
};

// 合作商标识
export const SUPPLIER_TYPE = {
    COLLABORATION: 1, // 合作商
    SUPPLIER_RESOURCE: 2, // 商资源
};


/**
 * 获取账号供应商全业态入驻信息
 * @param {Object} params - 查询参数
 * @param {Array} params.ytTypeList - 业态类型列表
 * @param {Number} params.hzType - 合作模式
 * @returns {Promise} 返回商家状态信息
 * @description
 * 返回值说明：
 * @list 账号供应商全业态入驻信息列表，列表中每个对象代表一个供应商入驻信息
 * @supplierId 合作商id
 * @merchantId 商资源id
 * @hzType 合作模式
 * @ytTypeList 业态类型
 * @supplierType 商家类型，1 合作商 2商资源
 * @state 商家状态  0-草稿 1-待审核 2-审核中 3-审核通过 4-审核不通过 5-已准入 999-当前账号存在供应商信息 -1-代表当前账号不存在招商信息
 * @refuseOpinion 驳回原因
 */
export const getMerchantStateApi = (params) => hPost('/api/vss/second/shepherd/sqm/merchantsSupplier/getSupplierMerchantStateInfo', params);

const getGrayResult = () => hPost('/api/vss/second/shepherd/SupplierSubmitManageTService/getGrayResult');
// 初始化商家状态
export const getMerchantState = async (options = {}) => {
    const {
        ytType,
        hzType,
    } = options;

    const params = {
        ytTypeList: ytType ? [ytType] : null,
        hzType: hzType || null,
    };

    // 获取灰度结果，决定调用哪个接口
    const isGrayOpen = await getGrayResult();

    let data;
    if (isGrayOpen) {
        // 灰度打开：调用新接口
        data = await hPost(
            '/api/vss/second/shepherd/SupplierSubmitManageTService/getSupplierStateInfo',
            params,
        );
    } else {
        // 灰度关闭：调用旧接口
        data = await getMerchantStateApi(params);
    }

    const list = data?.list || [];

    // 检查是否存在已绑定供货规则的供应商，supplierType为1，state为999的数据
    const boundMerchant = list.find((item) => +item.supplierType === SUPPLIER_TYPE.COLLABORATION && +item.state === MERCHANT_STATE.BOUND_MERCHANT) || null;

    let state = -1;
    let needBusinessSelect = true;

    if (ytType && hzType) {
        // 根据业态和合作模式查找匹配的商家
        const matchedMerchant = list.find((item) => +item.hzType === +hzType && (item.ytTypeList || []).includes(+ytType)) || null;
        state = matchedMerchant ? matchedMerchant.state : -1;
        needBusinessSelect = false;
    } else if (boundMerchant) {
        // 已绑定供货规则
        state = MERCHANT_STATE.BOUND_MERCHANT;
        needBusinessSelect = false;
    }

    return {
        state,
        needBusinessSelect, // 不存在合作商或未选择业态和合作模式，需要去选择业态和合作模式页面
    };
};
